
const GLOBAL: {
  scrollSmoothInstance: any;
} = {
  scrollSmoothInstance: null,
}

export { GLOBAL };